<template>
  <MetaHead title="Create An Account | Handcrafted" />

  <AuthGate
    :allow-anon-only="true"
    :force-visible="loadingState.isLoading()"
  >
    <FormWrapper
      id="reg-form-wrapper"
      :border="true"
      :pad="true"
      :loading-state="loadingState"
    >
      <template #heading>
        <h1>Create an account</h1>
        <!--          <BaseButton-->
        <!--            temperature="white"-->
        <!--            :to="{path: 'login'}"-->
        <!--            size="sm"-->
        <!--          >-->
        <!--            Log In-->
        <!--          </BaseButton>-->

        <template v-if="currentStep === Step.SELECT_ROLE">
          <p>Which type of account do you need?</p>
        </template>
      </template>

      <!--      <RegisterForm />-->
      <RegisterFormSelectMultistep
        ref="registerFlow"
        :loading-state="loadingState"
      />

      <template v-if="currentStep === Step.SELECT_ROLE">
        <div class="desc desc--bottom">
          <p>
            Please note that a state-issued seller permit, sales tax ID, VAT number, or equivalent is required to make
            purchases on Handcrafted.
          </p>
        </div>
      </template>
      <template v-else>
        <div class="desc desc--bottom">
          <p>
            By creating an account, you agree to Handcrafted's
            <router-link to="/legal/terms-use">
              Terms of Use
            </router-link>
            and
            <router-link to="/legal/privacy-policy">
              Privacy Policy,
            </router-link>
            including
            <router-link to="/legal">
              other associated policies.
            </router-link>
            We may send you communications; you may change your preferences in your account
            settings.
          </p>
        </div>
      </template>
    </FormWrapper>
  </AuthGate>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import RegisterFormSelectMultistep from '~/components/form/register/RegisterFormSelectMultistep.vue';
import { registrationStep } from '~/common/step';
import { useLoadingState } from '~/composables/states/loading-state';

const loadingState = useLoadingState();

const Step = registrationStep;

const registerFlow = ref<typeof RegisterFormSelectMultistep>();
const currentStep = computed(() => registerFlow?.value?.currentStep);
const isShowingForm = computed(() => currentStep.value === Step.REGISTER_CUSTOMER || currentStep.value === Step.REGISTER_SELLER);

</script>

<style lang="scss">
body:has(#reg-form-wrapper) {
  background: var(--color--bg-dark--alt);

  .section--newsletter-signup {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.form-wrapper {
  margin-top: 2em;
  margin-bottom: 2em;
  background: white;
  width: 25em;
  max-width: 100%;
  margin-inline: auto;
  position: relative;

  @media(max-width: 500px) {
    padding-inline: 1em;
    margin-inline: -.25em;
    max-width: calc(100% + .5em);
  }
}

header {
  margin-bottom: var(--space-sm);
}

h1 {
  font-size: var(--text-heading--h3);
}

.cols {
  display: flex;
  height: calc(100vh - 2.5em);

  &__col {
    &:first-child {
      display: flex;
      flex-flow: column;
      width: 30em;
      max-width: 100%;
      padding-right: 4em;
      margin-top: 7em;
    }

    &:last-child {
      background-color: var(--color--bg-dark);
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

:deep(form) {
  font-size: var(--text-sm);
}

.desc {
  font-style: italic;
  font-size: var(--text-xs);
  width: 100%;

  &--top {
    padding-bottom: var(--space-std);
  }

  &--bottom {
    padding-top: var(--space-std);
  }

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
}

h2 {
  margin-top: 0;
  margin-bottom: var(--space-xxxs);
}

</style>
